function getSlugTag(tag) {
    return String(tag).toLowerCase();
}

export { getSlugTag };
